// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__18HC5","row":"styles_row__1Z3wk"};